import { escapeHtml, } from '@/helpers/richEditorHelper';
const HTML_LINK_PATTERN = /<a\b[^>]*\bhref=(["'])(.*?)\1[^>]*>(.*?)<\/a>/gis;
const decodeHtml = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
};
const stripHtml = (value) => {
    const container = document.createElement('div');
    container.innerHTML = value;
    return container.textContent || '';
};
const isValidDomain = (value) => {
    return /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i
        .test(value);
};
export const getEmailTemplatePreviewHtml = (value) => {
    const links = [];
    const valueWithPlaceholders = value.replace(HTML_LINK_PATTERN, (match, quote, rawUrl, rawText) => {
        const index = links.length;
        const placeholder = `__PREVIEW_LINK_${index}__`;
        links.push({
            placeholder,
            url: decodeHtml(rawUrl),
            text: decodeHtml(stripHtml(rawText)),
        });
        return placeholder;
    });
    let result = escapeHtml(valueWithPlaceholders)
        .replace(/\n/g, '<br>');
    links.forEach(link => {
        const safeText = escapeHtml(link.text);
        if (!isValidDomain(link.url)) {
            result = result.replace(link.placeholder, safeText);
            return;
        }
        const safeUrl = escapeHtml(`https://${link.url}`);
        const linkHtml = (`<a href="${safeUrl}" ` +
            `target="_blank" ` +
            `rel="noopener noreferrer">` +
            `${safeText}</a>`);
        result = result.replace(link.placeholder, linkHtml);
    });
    return result;
};
